import {InputProps} from "types/types";
import {DeleteRoundIcon, CloseEyeIcon, OpenEyeIcon, InputLengthIcon} from "assets/icon";
import {PropsWithChildren, useEffect, useRef, useState} from "react";
import {useDownMd} from "../../hooks/useLayout";

export default function Input({
                                  onChange,
                                  type,
                                  after,
                                  showLength = false,
                                  showClear = true,
                                  className = '',
                                  rows = 1,
                                  maxRows = 4,
                                  children,
                                  ...props
                              }: InputProps & PropsWithChildren) {
    const [inputType, setInputType] = useState(type)
    const isDownMd = useDownMd()
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto';
            const lineHeight = 24;
            const maxHeight = lineHeight * 4;
            textarea.style.height = Math.min(textarea.scrollHeight, maxHeight) + 'px';
        }
    }, [props.value]);
    return <div
        className={`matchid-input-box matchid-input-${type} ${props.value && props.value.length > 0 ? 'matchid-input-has-content' : ''} ${className}`}
        style={{
            // @ts-ignore
            '--max-rows': maxRows
        }}
    >
        {children ?? (type == "textarea" ?
            <textarea rows={1} onChange={onChange} {...props} className="matchid-input-field" ref={textareaRef} style={{
                maxHeight: maxRows * 24 + 'px'
            }}/> :
            <input type={inputType} onChange={onChange} {...props} className="matchid-input-field"/>)}
        {
            type != "textarea" && showClear && props.value && props.value.length > 0
            && <div className="matchid-input-delete-icon" onClick={(e) => {
                if (onChange) {
                    onChange({target: {value: ''}});
                }
            }}>
                <DeleteRoundIcon height={isDownMd ? 16 : 21} width={isDownMd ? 16 : 20}
                                 color="var(--matchid-input-delete-icon-color)"/>
            </div>
        }
        {
            type === 'password' && <div className="matchid-input-eye-icon" onClick={() => {
                setInputType(inputType === 'password' ? 'text' : 'password')
            }}>
                {
                    inputType === 'password' ? <CloseEyeIcon size={isDownMd ? 16 : 20}/> :
                        <OpenEyeIcon size={isDownMd ? 16 : 20}/>
                }
            </div>
        }
        {
            showLength && props.maxLength && <div className={`matchid-input-length`}>
                <span>{props.value?.length || 0}/{props.maxLength}</span>
                <InputLengthIcon color={'var(--icon-color)'}/>
            </div>
        }
        {
            after
        }
    </div>

}